module.exports = __webpack_public_path__ + "static/media/timeframe.aac817db.mp4";